import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const PieChartIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M65.8519 38.8519C64.4447 53.0251 53.1732 64.2965 39 65.7038V38.8519H65.8519Z" fill="#C45227" />
      <path d="M65.8519 32.8519C64.4447 18.6786 53.1732 7.40721 39 6V32.8519H65.8519Z" fill="#E9004C" />
      <path d="M33 6V65.7038C17.84 64.1986 6 51.4079 6 35.8519C6 20.2958 17.84 7.50517 33 6Z" fill="#008563" />
    </SvgIcon>
  );
};

export default PieChartIcon;
